import { FC } from "react";
import { Outlet } from "react-router-dom";

export const EnterpriseRoute: FC = () => {
    return (
        <Outlet />
    )
}